import SecondaryService from "@/services/bytepro/secondary.service";

export const secondaryApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, fileDataId) {
      return SecondaryService.get(fileDataId).then(
        (resp) => {
          commit("dummy", "SecondaryService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "SecondaryService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { secondary, fileDataId }) {
      return SecondaryService.update(secondary, fileDataId).then(
        (resp) => {
          commit("dummy", "SecondaryService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "SecondaryService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
